/**
 * Custom Link Plugin for TinyMCE
 * Complete replacement for the default link plugin with search post functionality
 */

(function() {
  'use strict';

  // Check if TinyMCE is available
  if (typeof tinymce === 'undefined') {
    return;
  }

  // Register the plugin
  tinymce.PluginManager.add('customLink', function(editor) {
    'use strict';

    // Override the link command
    editor.addCommand('mceLink', function() {
      openLinkDialog();
    });

             // Override the unlink command
    editor.addCommand('unlink', function() {
      var selection = editor.selection;
      var selectedNode = selection.getNode();
      var selectedContent = selection.getContent();
      
      // Function to check if a node is inside embedblock or captionblock
      function isInsideProtectedElement(node) {
        var parent = node.parentNode;
        while (parent && parent.nodeType === 1) {
          if (parent.nodeName && 
              (parent.nodeName.toLowerCase() === 'embedblock' || 
               parent.nodeName.toLowerCase() === 'captionblock')) {
            return true;
          }
          parent = parent.parentNode;
        }
        return false;
      }
      
      // If there's selected content, process all links in the selection
      if (selectedContent && selectedContent.trim() !== '') {
        // Get the selection range
        var range = selection.getRng();
        var commonAncestor = range.commonAncestorContainer;
        
                 // Find all links that are ACTUALLY within the selection range
         var allLinks = [];
         
         // METHOD 1: Find links that are completely within the selection
         var selectionStart = range.startContainer;
         var selectionEnd = range.endContainer;
         
         // If selection is within a single text node, check if it's inside a link
         if (selectionStart === selectionEnd && selectionStart.nodeType === Node.TEXT_NODE) {
           var parentLink = editor.dom.getParent(selectionStart, 'a');
           if (parentLink && !isInsideProtectedElement(parentLink)) {
             allLinks.push(parentLink);
           }
         } else {
           // METHOD 2: Find all links in the document and check intersection
           var allDocumentLinks = editor.dom.select('a');
           
           for (var i = 0; i < allDocumentLinks.length; i++) {
             var link = allDocumentLinks[i];
             
             // Skip protected elements
             if (isInsideProtectedElement(link)) {
               continue;
             }
             
             // Check if this link intersects with our selection
             var linkRange = document.createRange();
             linkRange.selectNodeContents(link);
             
             // Check for intersection using multiple methods
             var hasIntersection = false;
             
             // Method A: Selection completely contains link
             if (range.compareBoundaryPoints(Range.START_TO_END, linkRange) <= 0 &&
                 range.compareBoundaryPoints(Range.END_TO_START, linkRange) >= 0) {
               hasIntersection = true;
             }
             // Method B: Selection starts inside link
             else if (link.contains(range.startContainer)) {
               hasIntersection = true;
             }
             // Method C: Selection ends inside link
             else if (link.contains(range.endContainer)) {
               hasIntersection = true;
             }
             // Method D: Link contains selection
             else if (range.compareBoundaryPoints(Range.START_TO_END, linkRange) >= 0 &&
                      range.compareBoundaryPoints(Range.END_TO_START, linkRange) <= 0) {
               hasIntersection = true;
             }
             // Method E: Check if selection and link overlap
             else {
               try {
                 // Create a range for the current selection
                 var selectionRange = document.createRange();
                 selectionRange.setStart(range.startContainer, range.startOffset);
                 selectionRange.setEnd(range.endContainer, range.endOffset);
                 
                 // Check if there's any intersection
                 if (selectionRange.compareBoundaryPoints(Range.START_TO_END, linkRange) < 0 &&
                     selectionRange.compareBoundaryPoints(Range.END_TO_START, linkRange) > 0) {
                   hasIntersection = true;
                 }
               } catch (e) {
                 // If range comparison fails, skip this link
               }
             }
             
             if (hasIntersection) {
               allLinks.push(link);
             }
           }
         }
         
        
        // Convert to array and filter out protected elements
        var linksToUnlink = [];
        for (var i = 0; i < allLinks.length; i++) {
          var link = allLinks[i];
          if (!isInsideProtectedElement(link)) {
            linksToUnlink.push(link);
          }
        }
        
        // Process each link for partial unlinking
        if (linksToUnlink.length > 0) {
          // Sort links by their position in the DOM to avoid conflicts
          linksToUnlink.sort(function(a, b) {
            return a.compareDocumentPosition(b) & Node.DOCUMENT_POSITION_FOLLOWING ? -1 : 1;
          });
          
                     linksToUnlink.forEach(function(linkElement) {
             var linkText = linkElement.textContent || linkElement.innerText;
             
             // Create a range for the entire link
             var linkRange = document.createRange();
             linkRange.selectNodeContents(linkElement);
             
             // SIMPLIFIED OVERLAP DETECTION: Check if selection intersects with this link
             var hasOverlap = false;
             var overlapStart = 0;
             var overlapEnd = linkText.length;
             
             // Check if selection is entirely within a text node inside the link (most common case)
             if (range.startContainer === range.endContainer && 
                 range.startContainer.nodeType === Node.TEXT_NODE && 
                 linkElement.contains(range.startContainer)) {
               
               var selectionStartPos = range.startOffset;
               var selectionEndPos = range.endOffset;
               
               // Only consider it overlap if we have a valid selection range
               if (selectionStartPos < selectionEndPos && selectionEndPos <= linkText.length) {
                 hasOverlap = true;
                 overlapStart = selectionStartPos;
                 overlapEnd = selectionEndPos;
               }
             }
             // Check if selection completely contains this link
             else if (range.compareBoundaryPoints(Range.START_TO_END, linkRange) <= 0 &&
                      range.compareBoundaryPoints(Range.END_TO_START, linkRange) >= 0) {
               hasOverlap = true;
               overlapStart = 0;
               overlapEnd = linkText.length;
             }
             // Check if selection starts or ends inside this link
             else if (linkElement.contains(range.startContainer) || linkElement.contains(range.endContainer)) {
               hasOverlap = true;
               
               if (linkElement.contains(range.startContainer)) {
                 if (range.startContainer === linkElement) {
                   overlapStart = 0;
                 } else if (range.startContainer.nodeType === Node.TEXT_NODE) {
                   overlapStart = range.startOffset;
                 }
               }
               
               if (linkElement.contains(range.endContainer)) {
                 if (range.endContainer === linkElement) {
                   overlapEnd = linkText.length;
                 } else if (range.endContainer.nodeType === Node.TEXT_NODE) {
                   overlapEnd = range.endOffset;
                 }
               }
               
             }
             
             if (hasOverlap && (overlapStart < overlapEnd)) {
               // Partial or full overlap - split the link
               var beforeText = linkText.substring(0, overlapStart);
               var selectedText = linkText.substring(overlapStart, overlapEnd);
               var afterText = linkText.substring(overlapEnd);
               
               // Create new content: beforeText + selectedText + afterText
               var newContent = [];
               
               if (beforeText) {
                 // Create link for the part before selection
                 var beforeLink = editor.dom.create('a', {
                   href: linkElement.href,
                   title: linkElement.title,
                   target: linkElement.target,
                   rel: linkElement.rel
                 }, beforeText);
                 newContent.push(beforeLink);
               }
               
               // Add the selected text (unlinked)
               newContent.push(editor.dom.create('text', {}, selectedText));
               
               if (afterText) {
                 // Create link for the part after selection
                 var afterLink = editor.dom.create('a', {
                   href: linkElement.href,
                   title: linkElement.title,
                   target: linkElement.target,
                   rel: linkElement.rel
                 }, afterText);
                 newContent.push(afterLink);
               }
               
               // Replace the original link with the new content
               if (newContent.length > 0) {
                 editor.dom.replace(newContent[0], linkElement);
                 for (var j = 1; j < newContent.length; j++) {
                   editor.dom.insertAfter(newContent[j], newContent[j-1]);
                 }
               }
             } else {
               // No overlap - unlink entire link
               editor.dom.replace(editor.dom.create('text', {}, linkText), linkElement);
             }
           });
        } else {
          // No links found in selection, check if we're inside a link
          var parentLink = editor.dom.getParent(selectedNode, 'a');
          if (parentLink && !isInsideProtectedElement(parentLink)) {
            var linkText = parentLink.textContent || parentLink.innerText;
            editor.dom.replace(editor.dom.create('text', {}, linkText), parentLink);
          }
        }
        
      } else {
        // No selection - handle single link at cursor position (unlink entire link)
        var isLink = selectedNode.nodeName === 'A';
        
        // If we're inside a link, get the link element
        if (!isLink) {
          var linkElement = editor.dom.getParent(selectedNode, 'a');
          if (linkElement) {
            isLink = true;
            selectedNode = linkElement;
          }
        }
        
        if (isLink) {
          // Check if the link is inside embedblock or captionblock custom elements
          var parent = selectedNode.parentNode;
          var shouldSkip = false;
          
          while (parent && parent.nodeType === 1) {
            if (parent.nodeName && 
                (parent.nodeName.toLowerCase() === 'embedblock' || 
                 parent.nodeName.toLowerCase() === 'captionblock')) {
              shouldSkip = true;
              break;
            }
            parent = parent.parentNode;
          }
          
          if (!shouldSkip) {
            // Get the text content of the link
            var linkText = selectedNode.textContent || selectedNode.innerText;
            
            // Replace the link with its text content
            editor.dom.replace(editor.dom.create('text', {}, linkText), selectedNode);
            
            // Set selection to the text
            selection.setCursorLocation(selectedNode);
          }
        }
      }
    });

    function openLinkDialog() {
      // Get current selection
      var selection = editor.selection;
      var selectedText = selection.getContent({format: 'text'});
      var selectedNode = selection.getNode();
      var isLink = selectedNode.nodeName === 'A';
      
      // If we're inside a link, get the link element
      if (!isLink) {
        var linkElement = editor.dom.getParent(selectedNode, 'a');
        if (linkElement) {
          isLink = true;
          selectedNode = linkElement;
        }
      }

      // Helper function to decode HTML entities from title attributes
      function decodeTitle(title) {
        if (!title) return '';
        // Create a temporary element to decode HTML entities
        var div = document.createElement('div');
        div.innerHTML = title;
        return div.textContent || div.innerText || '';
      }

      // Helper function to get the correct rel value for the dropdown
      function getRelValue(rel) {
        if (!rel) return '';
        
        // Split the rel attribute into individual values
        var relValues = rel.split(' ').map(function(val) { return val.trim(); });
        
        // Check for nofollow or sponsored (ignore noopener as it's added automatically)
        if (relValues.indexOf('nofollow') !== -1) {
          return 'nofollow';
        }
        if (relValues.indexOf('sponsored') !== -1) {
          return 'sponsored';
        }
        
        return '';
      }

      // Create modal using TinyMCE's window manager (uses original CSS)
      var win = editor.windowManager.open({
        title: 'Insert/edit link',
        body: {
          type: 'form',
          items: [
            {
              type: 'textbox',
              name: 'url',
              label: 'URL',
              value: isLink ? selectedNode.href : ''
            },
            {
              type: 'textbox',
              name: 'search',
              label: 'Search posts',
              placeholder: 'Search...'
            },
            {
              type: 'textbox',
              name: 'text',
              label: 'Text to display',
              value: isLink ? (selectedNode.textContent || selectedNode.innerText) : selectedText
            },
            {
              type: 'textbox',
              name: 'title',
              label: 'Title',
              value: isLink ? decodeTitle(selectedNode.title) : ''
            },
            {
              type: 'listbox',
              name: 'rel',
              label: 'Rel',
              values: [
                {text: 'DoFollow', value: ''},
                {text: 'NoFollow', value: 'nofollow'},
                {text: 'Sponsored', value: 'sponsored'}
              ],
              value: isLink ? getRelValue(selectedNode.rel) : ''
            },
            {
              type: 'listbox',
              name: 'target',
              label: 'Target',
              values: [
                {text: 'Current window', value: ''},
                {text: 'New window', value: '_blank'}
              ],
              value: isLink ? (selectedNode.target === '_blank' ? '_blank' : '') : '_blank'
            }
          ]
        },
        onsubmit: function(e) {
          var data = e.data;
          var text = data.text.trim();
          var url = data.url.trim();
          var title = data.title.trim();
          var target = data.target;
          var rel = data.rel;

          if (!text) {
            alert('Please enter text to display');
            return;
          }

          // If no URL is provided, just close the modal (like native TinyMCE)
          if (!url) {
            return;
          }

          // Add noopener to rel when target is _blank
          if (target === '_blank') {
            if (rel && rel !== '') {
              // Check if noopener is already present
              if (rel.indexOf('noopener') === -1) {
                rel = rel + ' noopener';
              }
            } else {
              rel = 'noopener';
            }
          }

          // Insert or update the link
          var selection = editor.selection;
          var selectedNode = selection.getNode();
          var isLink = selectedNode.nodeName === 'A';
          
          // If we're inside a link, get the link element
          if (!isLink) {
            var linkElement = editor.dom.getParent(selectedNode, 'a');
            if (linkElement) {
              isLink = true;
              selectedNode = linkElement;
            }
          }

          if (isLink) {
            // Update existing link using setAttrib to avoid parsing issues
            selectedNode.href = url;
            editor.dom.setAttrib(selectedNode, 'data-mce-href', url);
            if (title) {
              editor.dom.setAttrib(selectedNode, 'title', title);
            } else {
              editor.dom.setAttrib(selectedNode, 'title', null);
            }
            editor.dom.setAttrib(selectedNode, 'target', target);
            editor.dom.setAttrib(selectedNode, 'rel', rel);
            selectedNode.textContent = text;
          } else {
                         // Insert new link - wrap selected text with link
             var selectedContent = selection.getContent();
             
             if (selectedContent && selectedContent.trim() !== '') {
               // ✅ FIXED: Preserve trailing whitespace from selection
               var trailingWhitespace = '';
               
               // Check if the selected content ends with whitespace
               if (selectedContent.match(/\s+$/)) {
                 var whitespaceMatch = selectedContent.match(/(\s+)$/);
                 if (whitespaceMatch) {
                   trailingWhitespace = whitespaceMatch[1];
                 }
               }
               
               // Create the link HTML with the selected text content (without trailing whitespace)
               var linkHtml = '<a href="' + url + '"';
               if (title) {
                 linkHtml += ' title="' + title.replace(/"/g, '&quot;') + '"';
               }
               if (target) {
                 linkHtml += ' target="' + target + '"';
               }
               if (rel) {
                 linkHtml += ' rel="' + rel + '"';
               }
               linkHtml += '>' + text + '</a>';
               
               // Replace selection with link + preserved whitespace
               var finalContent = linkHtml + trailingWhitespace;
               selection.setContent(finalContent);
            } else {
              // No selection, insert link at cursor position
              var linkHtml = '<a href="' + url + '"';
              if (title) {
                linkHtml += ' title="' + title.replace(/"/g, '&quot;') + '"';
              }
              if (target) {
                linkHtml += ' target="' + target + '"';
              }
              if (rel) {
                linkHtml += ' rel="' + rel + '"';
              }
              linkHtml += '>' + text + '</a>';
              
              editor.insertContent(linkHtml);
            }
          }
        }
      });

      // Fix modal width and spacing after window is created
      setTimeout(function() {
        var modalWindow = document.querySelector('.mce-window[aria-label="Insert/edit link"]');
        if (modalWindow) {
          modalWindow.style.width = '469px';
          modalWindow.style.minWidth = '469px';
          modalWindow.style.maxWidth = '469px';
          modalWindow.style.height = '350px';
        }
        
        // Fix the modal body
        var modalBody = modalWindow ? modalWindow.querySelector('.mce-window-body') : null;
        if (modalBody) {
          modalBody.style.width = '469px';
          modalBody.style.height = '260px';
        }
        
        // Fix the main form container
        var mainForm = modalWindow ? modalWindow.querySelector('.mce-form') : null;
        if (mainForm) {
          mainForm.style.width = '469px';
          mainForm.style.height = '260px';
        }
        
        var mainFormBody = mainForm ? mainForm.querySelector('.mce-container-body') : null;
        if (mainFormBody) {
          mainFormBody.style.width = '469px';
          mainFormBody.style.height = '260px';
        }
        
        // Fix the extra nested form container
        var nestedForm = modalWindow ? modalWindow.querySelector('.mce-form .mce-form') : null;
        if (nestedForm) {
          nestedForm.style.left = '0px';
          nestedForm.style.top = '0px';
          nestedForm.style.width = '469px';
          nestedForm.style.height = '260px';
        }
        
        var nestedFormBody = nestedForm ? nestedForm.querySelector('.mce-container-body') : null;
        if (nestedFormBody) {
          nestedFormBody.style.width = '469px';
          nestedFormBody.style.height = '260px';
        }
        
        // Fix the footer
        var footer = modalWindow ? modalWindow.querySelector('.mce-foot') : null;
        if (footer) {
          footer.style.width = '469px';
        }
        
        var footerBody = footer ? footer.querySelector('.mce-container-body') : null;
        if (footerBody) {
          footerBody.style.width = '469px';
        }
        
        // Fix form items to use full width like original
        var formItems = modalWindow ? modalWindow.querySelectorAll('.mce-formitem') : [];
        formItems.forEach(function(formItem, index) {
          formItem.style.width = '439px';
          formItem.style.left = '15px';
          formItem.style.top = (15 + (index * 40)) + 'px';
          formItem.style.height = '30px';
          
          var formItemBody = formItem.querySelector('.mce-container-body');
          if (formItemBody) {
            formItemBody.style.width = '439px';
            formItemBody.style.height = '30px';
          }
          
          // Expand input fields to match original widths
          var inputField = formItem.querySelector('.mce-textbox');
          if (inputField) {
            inputField.style.width = '310px';
          }
          
          var listbox = formItem.querySelector('.mce-listbox');
          if (listbox) {
            listbox.style.width = '318px';
          }
        });
        
        // Fix absolute end elements
        var absEndElements = modalWindow ? modalWindow.querySelectorAll('.mce-abs-end') : [];
        absEndElements.forEach(function(absEnd) {
          absEnd.style.width = '0px';
          absEnd.style.height = '0px';
        });
      }, 100);

      // Initialize search functionality after window is created
      setTimeout(function() {
        var searchInput = win.find('#search')[0];
        var urlInput = win.find('#url')[0];
        
        if (searchInput && urlInput) {
          initializeSearchFunctionality(searchInput, urlInput, win);
        }
        
        // Fix listbox dropdown positioning
        var relListbox = win.find('#rel')[0];
        var targetListbox = win.find('#target')[0];
        
        // Set up MutationObserver to catch dropdown creation
        var observer = new MutationObserver(function(mutations) {
          mutations.forEach(function(mutation) {
            if (mutation.type === 'childList') {
              mutation.addedNodes.forEach(function(node) {
                if (node.nodeType === 1 && node.classList && 
                    node.classList.contains('mce-floatpanel') && 
                    node.classList.contains('mce-menu')) {
                  // Hide the dropdown immediately
                  node.style.visibility = 'hidden';
                  
                  // Find which listbox triggered this
                  var activeListbox = document.querySelector('.mce-listbox.mce-active');
                  if (activeListbox) {
                    setTimeout(function() {
                      fixDropdownPosition(activeListbox);
                    }, 5);
                  }
                }
              });
            }
          });
        });
        
        // Start observing
        observer.observe(document.body, {
          childList: true,
          subtree: true
        });
        
        if (relListbox) {
          relListbox.on('click', function() {
            // The observer will handle the positioning
          });
        }
        
        if (targetListbox) {
          targetListbox.on('click', function() {
            // The observer will handle the positioning
          });
        }
      }, 100);
      
      function fixDropdownPosition(listbox) {
        var listboxEl = listbox.getEl ? listbox.getEl() : listbox;
        if (!listboxEl) return;
        
        // Find the dropdown menu
        var dropdown = document.querySelector('.mce-floatpanel.mce-menu.mce-in');
        if (!dropdown) return;
        
        // Get the position of the listbox field
        var rect = listboxEl.getBoundingClientRect();
        
        // Position the dropdown relative to the listbox
        dropdown.style.left = rect.left + 'px';
        dropdown.style.top = (rect.bottom + 2) + 'px';
        dropdown.style.position = 'fixed';
        dropdown.style.transform = 'none';
        dropdown.style.width = rect.width + 'px';
        
        // Also fix the dropdown body width
        var dropdownBody = dropdown.querySelector('.mce-container-body');
        if (dropdownBody) {
          dropdownBody.style.width = rect.width + 'px';
        }
        
        // Show the dropdown after positioning
        setTimeout(function() {
          dropdown.style.visibility = 'visible';
        }, 10);
      }
    }

    function initializeSearchFunctionality(searchInput, urlInput, win) {
      // Helper function to escape HTML entities
      function escapeHtml(text) {
        var div = document.createElement('div');
        div.textContent = text;
        return div.innerHTML;
      }
      
      // Helper function to decode HTML entities
      function decodeHtml(text) {
        if (!text || text.length === 0) {
          return '';
        }
        
        var div = document.createElement('div');
        div.innerHTML = text;
        var result = div.textContent;
        
        return result;
      }
      
      // Create results container
      var resultsContainer = document.createElement('div');
      resultsContainer.id = 'search-results';
      resultsContainer.className = 'mce-menu mce-menu-align';
      resultsContainer.style.cssText = 'position: absolute; top: calc(100% + -1px); left: 0; right: 0; background: white; border: 1px solid #ccc; max-height: 250px; margin-top:0; border-radius: 0; overflow-y: auto; z-index: 1000; display: none; box-shadow: 0 2px 4px rgba(0,0,0,0.1);';
      
      // Insert results container after search input
      var searchGroup = searchInput.getEl().closest('.mce-formitem');
      if (searchGroup) {
        searchGroup.style.position = 'relative';
        searchGroup.appendChild(resultsContainer);
      }
      
      // Pagination variables
      var searchPage = 0;
      var allPosts = [];
      var totalResults = 0;
      var currentQuery = '';
      
      // Search functionality using searchPost directive
      searchInput.on('input', function() {
        var query = this.value().trim();
        
        if (query.length < 2) {
          resultsContainer.style.display = 'none';
          return;
        }
        
        // Reset pagination for new search
        searchPage = 0;
        allPosts = [];
        currentQuery = query;
        
        // Show loading state
        resultsContainer.innerHTML = 
          '<div style="padding: 10px; text-align: center; color: #666;">' +
            '<div>Searching for posts...</div>' +
          '</div>';
        resultsContainer.style.display = 'block';
        
        // Perform search
        performSearch(query, searchPage, false);
      });
      
      // Function to perform search with pagination
      function performSearch(query, page, isLoadMore) {
        // Use the same approach as searchPostDirective
        // First, we need to construct the elasticSearch URL manually since we can't access the service
        var searchData = query;
        
        // Clean the search data (same logic as elasticSearch service)
        // Remove words containing special characters
        searchData = searchData.replace(/\b[a-zA-Z0-9ćĆčČđĐšŠžŽ]*[^a-zA-Z0-9ćĆčČđĐšŠžŽ\s]+[a-zA-Z0-9ćĆčČđĐšŠžŽ]*\b/g, '');
        
        // Remove all special characters for elastic search
        searchData = searchData.replace(/[^a-zA-Z0-9ćĆčČđĐšŠžŽ\s]/g, '');
        
        // Trim whitespace
        searchData = searchData.trim();
        
        // Split into words
        var words = searchData.split(/\s+/);
        
        // Clean empty words
        words = words.filter(function(word) { return word.length > 0; });
        
        var postSearch = '';
        for(var i = 0; i < words.length; i++) {
          if(i == 0) { 
            if(!isNaN(words[i])) {
              if(words[i].length >= 5) {
                postSearch = 'id:' + words[i] + '*';
              } else {
                if(words[i].indexOf("*") == -1) {
                  words[i] += '*';
                }
                postSearch = postSearch.concat('post_title:' + words[i]);
              }
            } else {
              if(words[i].indexOf("*") == -1) {
                words[i] += '*';
              }
              postSearch = postSearch.concat('post_title:' + words[i]);
            }
          } else {
            if(words[i].indexOf("*") == -1) {
              words[i] += '*';
            }
            postSearch = postSearch.concat('%20AND%20post_title:' + words[i]);
          }
        }
        
        // Construct the elasticSearch URL (same as searchPostDirective)
        var baseUrl = 'https://pretraga.telegraf.rs/eklinika_posts/_search';
        var apiUrl = baseUrl + '?q=' + postSearch + '&sort=uts:desc&from=' + page + '&size=10';
        
        // Make direct elasticSearch API call (same as searchPostDirective)
        fetch(apiUrl, {
          method: 'GET',
          headers: {
            'Accept': 'application/json'
          }
        })
          .then(function(response) {
            if (!response.ok) {
              throw new Error('Network response was not ok: ' + response.status);
            }
            return response.json();
          })
          .then(function(data) {
            // Handle elasticSearch response format (same as searchPostDirective: data.hits.hits)
            var posts = data && data.hits && data.hits.hits ? data.hits.hits : [];
            totalResults = data && data.hits && data.hits.total ? data.hits.total : 0;
            
            if (isLoadMore) {
              // Append to existing posts
              allPosts = allPosts.concat(posts);
            } else {
              // Replace posts for new search
              allPosts = posts;
            }
            
            if (allPosts.length > 0) {
              var resultsHtml = '';
              allPosts.forEach(function(post) {
                var postData = post._source;
                var postUrl = postData.url || '/post/' + post._id;
                var postTitle = postData.post_title || 'Untitled';
                
                resultsHtml += 
                  '<div class="mce-menu-item" style="padding: 8px 12px!important; white-space: normal; border-left:none; cursor: pointer; border-bottom: 1px solid #f0f0f0;" ' +
                       'data-url="' + encodeURIComponent(postUrl) + '" data-title="' + postTitle.replace(/"/g, '&quot;') + '">' +
                    '<div style="font-weight: bold; white-space: normal;">(' + post._id + ') - ' + postTitle.replace(/"/g, '&quot;') + '</div>' +
                  '</div>';
              });
              
              // Add Load More button if there are more results
              if (totalResults > allPosts.length) {
                resultsHtml += '<div class="mce-menu-item load-more-btn" style="padding: 10px 12px; text-align: center; background-color: #f8f9fa; border-bottom: none; cursor: pointer;">' +
                    '<button style="background: #2d8ac7; color: white; border: none; padding: 8px 16px; border-radius: 4px; cursor: pointer; font-size: 12px;">Load More</button>' +
                  '</div>';
              }
              
              resultsContainer.innerHTML = resultsHtml;
              
              // Add click handlers to results
              var menuItems = resultsContainer.querySelectorAll('.mce-menu-item:not(.load-more-btn)');
              menuItems.forEach(function(item) {
                item.addEventListener('click', function() {
                  var url = decodeURIComponent(this.getAttribute('data-url'));
                  var encodedTitle = this.getAttribute('data-title');
                  var title = encodedTitle.replace(/&quot;/g, '"');
                  
                  // Update URL field
                  urlInput.value(url);
                  
                  // Update only the title field (not the display text)
                  var titleInput = win.find('#title')[0];
                  
                  if (titleInput) {
                    // Try multiple approaches to update the title field properly
                    
                    // Approach 1: Direct DOM manipulation first
                    var domElement = titleInput.getEl();
                    if (domElement) {
                      domElement.value = title;
                      domElement.setAttribute('value', title);
                      domElement.dispatchEvent(new Event('input', { bubbles: true }));
                      domElement.dispatchEvent(new Event('change', { bubbles: true }));
                    }
                    
                    // Approach 2: Use TinyMCE field API
                    setTimeout(function() {
                      titleInput.value(title);
                      titleInput.fire('change');
                    }, 50);
                    
                    // Approach 3: Try using the dialog's data API
                    try {
                      var dialogData = win.getData();
                      dialogData.title = title;
                      win.setData(dialogData);
                    } catch (e) {
                    }
                    
                    // Approach 4: Force update with multiple methods
                    setTimeout(function() {
                      // Try setting value multiple ways
                      titleInput.value(title);
                      if (domElement) {
                        domElement.value = title;
                        domElement.setAttribute('value', title);
                        domElement.dispatchEvent(new Event('input', { bubbles: true }));
                        domElement.dispatchEvent(new Event('change', { bubbles: true }));
                      }
                      titleInput.fire('change');
                    }, 100);
                    
                  } else {
                  }
                  
                  // Hide results
                  resultsContainer.style.display = 'none';
                  
                  // Focus on URL field
                  urlInput.focus();
                });
              });
              
              // Add click handler for Load More button
              var loadMoreBtn = resultsContainer.querySelector('.load-more-btn');
              if (loadMoreBtn) {
                loadMoreBtn.addEventListener('click', function() {
                  searchPage += 10;
                  performSearch(currentQuery, searchPage, true);
                });
              }
            } else {
              resultsContainer.innerHTML = 
                '<div style="padding: 10px; text-align: center; color: #666;">' +
                  '<div>No posts found</div>' +
                '</div>';
            }
          })
          .catch(function(error) {
            resultsContainer.innerHTML = 
              '<div style="padding: 10px; text-align: center; color: #666;">' +
                '<div>Error searching posts: ' + error.message + '</div>' +
              '</div>';
          });
      }
      
      // Hide results when clicking outside
      document.addEventListener('click', function(e) {
        if (!searchInput.getEl().contains(e.target) && !resultsContainer.contains(e.target)) {
          resultsContainer.style.display = 'none';
        }
      });
      
      // Handle keyboard navigation
      searchInput.on('keydown', function(e) {
        if (e.keyCode === 40 || e.keyCode === 38) { // ArrowDown or ArrowUp
          e.preventDefault();
          var menuItems = resultsContainer.querySelectorAll('.mce-menu-item:not(.load-more-btn)');
          var currentIndex = -1;
          
          // Find currently selected item
          for (var i = 0; i < menuItems.length; i++) {
            if (menuItems[i].classList.contains('mce-selected')) {
              currentIndex = i;
              break;
            }
          }
          
          if (e.keyCode === 40) { // ArrowDown
            currentIndex = (currentIndex + 1) % menuItems.length;
          } else { // ArrowUp
            currentIndex = (currentIndex - 1 + menuItems.length) % menuItems.length;
          }
          
          // Update selection
          menuItems.forEach(function(item) {
            item.classList.remove('mce-selected');
          });
          
          if (menuItems[currentIndex]) {
            menuItems[currentIndex].classList.add('mce-selected');
          }
        } else if (e.keyCode === 13) { // Enter
          e.preventDefault();
          var selectedItem = resultsContainer.querySelector('.mce-menu-item.mce-selected');
          if (selectedItem) {
            selectedItem.click();
          }
        }
      });
    }

    // Add button to toolbar
    editor.addButton('link', {
      title: 'Insert/edit link',
      cmd: 'mceLink'
    });

    // Add unlink button to toolbar
    editor.addButton('unlink', {
      title: 'Remove link',
      cmd: 'unlink'
    });

    // Add menu item
    editor.addMenuItem('link', {
      text: 'Link',
      cmd: 'mceLink',
      context: 'insert'
    });

    // Add unlink menu item
    editor.addMenuItem('unlink', {
      text: 'Remove link',
      cmd: 'unlink',
      context: 'insert'
    });

    // Update toolbar state when selection changes
    editor.on('NodeChange', function(e) {
      try {
        var selection = editor.selection;
        var selectedNode = selection.getNode();
        
        // Check if we're inside a link
        var linkElement = editor.dom.getParent(selectedNode, 'a');
        var isLink = linkElement !== null;
        
        // Update button states using DOM manipulation since TinyMCE button API is limited
        var toolbar = editor.getContainer().querySelector('.mce-toolbar-grp');
        if (toolbar) {
          // Find buttons by their command or by looking for buttons with specific text
          var linkButton = toolbar.querySelector('.mce-btn[data-mce-command="mceLink"], .mce-btn[aria-label*="link"], .mce-btn[title*="link"]');
          var unlinkButton = toolbar.querySelector('.mce-btn[data-mce-command="unlink"], .mce-btn[aria-label*="unlink"], .mce-btn[title*="unlink"]');
          
          // If we can't find by command, try to find by button text content
          if (!linkButton) {
            var buttons = toolbar.querySelectorAll('.mce-btn');
            for (var i = 0; i < buttons.length; i++) {
              var btn = buttons[i];
              var btnText = btn.textContent || btn.innerText || '';
              if (btnText.toLowerCase().includes('link') && !btnText.toLowerCase().includes('unlink')) {
                linkButton = btn;
                break;
              }
            }
          }
          
          if (!unlinkButton) {
            var buttons = toolbar.querySelectorAll('.mce-btn');
            for (var i = 0; i < buttons.length; i++) {
              var btn = buttons[i];
              var btnText = btn.textContent || btn.innerText || '';
              if (btnText.toLowerCase().includes('unlink')) {
                unlinkButton = btn;
                break;
              }
            }
          }
          
          // Try alternative selectors for unlink button
          if (!unlinkButton) {
            unlinkButton = toolbar.querySelector('.mce-btn[data-mce-command="unlink"]');
          }
          if (!unlinkButton) {
            unlinkButton = toolbar.querySelector('.mce-btn[title*="unlink"]');
          }
          if (!unlinkButton) {
            unlinkButton = toolbar.querySelector('.mce-btn[aria-label*="unlink"]');
          }
          if (!unlinkButton) {
            unlinkButton = toolbar.querySelector('.mce-btn[title*="Unlink"]');
          }
          if (!unlinkButton) {
            unlinkButton = toolbar.querySelector('.mce-btn[aria-label*="Unlink"]');
          }
          
          // Use the correct aria-label selectors based on debugging
          if (!linkButton) {
            linkButton = toolbar.querySelector('.mce-btn[aria-label="Insert/edit link"]');
          }
          if (!unlinkButton) {
            unlinkButton = toolbar.querySelector('.mce-btn[aria-label="Remove link"]');
          }
          
          // Update link button state
          if (linkButton) {
            if (isLink) {
              linkButton.classList.add('mce-active');
              linkButton.setAttribute('aria-pressed', 'true');
            } else {
              linkButton.classList.remove('mce-active');
              linkButton.setAttribute('aria-pressed', 'false');
            }
          }
          
          // Update unlink button state
          if (unlinkButton) {
            if (isLink) {
              unlinkButton.classList.add('mce-active');
              unlinkButton.setAttribute('aria-pressed', 'true');
            } else {
              unlinkButton.classList.remove('mce-active');
              unlinkButton.setAttribute('aria-pressed', 'false');
            }
          }
        } else {
        }
      } catch (error) {
      }
    });
  });
})();
    


//////////////////
// WEBPACK FOOTER
// ./public/development/assets/custom-external-script/tinymce/plugins/custom-link/plugin.js
// module id = 473
// module chunks = 0